import { TreeTooltipList } from './types';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

const tooltipList: TreeTooltipList = {
    isVirtualSensor: {
        class: 'virtual-sensor',
        tooltipText: 'Virtual sensor',
        text: 'V',
    },
    isActive: {
        class: '',
        materialIcon: 'circle',
        materialIconClass: 'cl-status-active',
        tooltipText: 'Has Active Sensor Data'
    },
    isDuplicateModbusId: {
        class: '',
        materialIcon: 'error',
        tooltipText: 'Duplicate Modbus Id!'
    },
    isStale: {
        class: '',
        materialIcon: 'circle',
        materialIconClass: 'cl-status-stale',
        tooltipText: 'Stale Sensor Data'
    },
    isNotResponding: {
        class: '',
        materialIcon: 'circle',
        materialIconClass: 'cl-status-notresponding',
        tooltipText: 'Not Responding',
    },
    isInActive: {
        class: '',
        materialIcon: 'circle',
        materialIconClass: 'cl-status-inactive',
        tooltipText: 'No Active Sensor Data'
    },
    isFailure: {
        class: '',
        materialIcon: 'circle',
        materialIconClass: 'cl-status-failure',
        tooltipText: 'Reader Failure'
    },
    $refreshData: {
        class: '',
        tooltipText: 'Loading data...',
        isPreloader: true,
    },
    $addDevice: {
        class: '',
        tooltipText: 'Sync in progress!',
        isPreloader: true,
    },
    $removeDevice: {
        class: '',
        tooltipText: 'Deleting device...',
        isPreloader: true,
    },
}

export function isTooltip(attribute: { key: string, value: boolean }) {
    return tooltipList[attribute.key] && attribute.value === true;
}

@Component({
    selector: 'cl-basic-tree-tooltip',
    templateUrl: './basic-tree-tooltip.component.html',
    styleUrls: ['basic-tree-tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicTreeTooltipComponent {
    @Input() tooltipName: string;

    get tooltip() {
        if (!(this.tooltipName in tooltipList)) {
            throw new Error('Tooltip not supported. Please add it into list.');
        }
        return tooltipList[this.tooltipName];
    }
}
